
function addinitial(total,total2)
{

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    success: function() {
      console.log('pass2:' + total);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:  "quantity=" + total + "&id=31342279690",
        success: function(data) { 
          if ( total != total2 ) 
            $(location).attr('href',"/cart");
        }
      }); 
    },
    data:  "quantity=0&id=31342279690" 
  });   
}
